module.exports = __webpack_public_path__ + "img/c-16.d3a9d681.jpg";